import React from 'react';
import styled from 'styled-components';
import colors from '../../../helpers/colors';

const CTAButton = styled.a`
    border: 2px solid ${colors.mvVividBlue};
    text-transform: none;
    font-size: 15px;
    font-weight: bold;
    padding: 11px 23px;
    border-radius: ${props => props.$borderRadius};
    color: ${colors.mvVividBlue};
    cursor: pointer;
    text-decoration: none;
    transition: .3s;
    width: auto;
    padding: 13px 30px;
    display: inline-block;

    &:hover {
        text-decoration: none;
        background: ${colors.mvVividBlue};
        transition: .4s;
        color: ${colors.mvWhite};

        a {
            text-decoration: underline;
            color: ${colors.mvWhite};
        }
    }

    a {
        text-decoration: none;
    }
`;

CTAButton.defaultProps = {
    $borderRadius: '55px'
};

const CTA = ({ctaHref, ctaText, color}) => {
    return (
        <CTAButton href={ctaHref} color={color}>
            {ctaText}
        </CTAButton>
    )
}

export default CTA;